import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseMaintenanceEstablishmentTechnicalProfessionalsProps<T> = {
  filters?: {
    page?: number;
    search?: string;
  };
  mapper?: (data: any) => T;
};

export const useMaintenanceEstablishmentTechnicalProfessionals = <T,>({
  filters: {
    page,
    search,
  } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceEstablishmentTechnicalProfessionalsProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: [
      'maintenanceEstablishmentTechnicalProfessionals',
      page,
      search,
    ],
    queryFn: () => {
      return privateAxios.get('/maintenance/establishment_technical_professionals', {
        params: {
          page,
          search,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
